import { render, staticRenderFns } from "./SalesPoints.vue?vue&type=template&id=230e70f6"
import script from "./SalesPoints.vue?vue&type=script&lang=js"
export * from "./SalesPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports